<template>
  <div>
    <requirement-document-type-add-new
      :is-add-new-requirement-document-type-sidebar-active.sync="isAddNewRequirementDocumentTypeSidebarActive"
      @refresh-data="() => { refRequirementDocumentTypeList.refreshData() }"
    />
    <list
      ref="refRequirementDocumentTypeList"
      sort-by="requerimientoDocumentoTipoId"
      :refetch-records="fetchRequirementDocumentTypes"
      refetch-records-name="documentoTipos"
      :actions="actions"
      key-field="requerimientoDocumentoTipoId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteRequirementDocumentType"
      :filters.sync="filters"
    />
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import actionsImprovement from '@/services/actionsImprovement.service'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import RequirementDocumentTypeAddNew from './RequirementDocumentTypeAddNew.vue'

export default {
  components: {
    RequirementDocumentTypeAddNew,
    List,
  },
  setup() {
    /* Refs */
    const refRequirementDocumentTypeList = ref(null)
    const isAddNewRequirementDocumentTypeSidebarActive = ref(false)
    /* Services */
    const { fetchRequirementDocumentTypes, fetchRequirementDocumentType, deleteRequirementDocumentType } = actionsImprovement()
    const tableColumns = [
      {
        label: 'Nombre',
        key: 'nombre',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'write',
        aclResource: 'AccionesMejora',
        routeName: 'apps-requirement-quality-type-edit',
        params: ['requerimientoDocumentoTipoId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'AccionesMejora',
        params: ['requerimientoDocumentoTipoId'],
        // disabledCondition: item => item.estadoCivilId === 3,
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        label: 'Nuevo requerimiento calidad tipo',
        aclAction: 'create',
        click: () => { isAddNewRequirementDocumentTypeSidebarActive.value = true },
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      // Ref
      refRequirementDocumentTypeList,
      tableColumns,
      isAddNewRequirementDocumentTypeSidebarActive,
      tableActions,
      actions,
      filters,
      // API Calls
      fetchRequirementDocumentTypes,
      fetchRequirementDocumentType,
      deleteRequirementDocumentType,
    }
  },
}
</script>
<style lang="scss" scoped>

</style>
